import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './AlvarasPage.css';

const AlvarasPage = () => {
  return (
    <>
      <Header />
      
      <div className="alvaras-container">
        <div className="alvaras-content">
          <div className="alvaras-left">
            <div className="alvaras-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">EMISSÃO DE ALVARÁS E AUTORIZAÇÕES</h1>
            </div>
          </div>
          
          <div className="alvaras-right">
            <div className="alvaras-description">
              <p className="alvaras-intro">
                Cuidamos de todas as licenças necessárias para que sua empresa funcione em 
                conformidade, sem complicações.
              </p>
              
              <ul className="alvaras-services">
                <li>Alvará de funcionamento e localização;</li>
                <li>Licenças sanitárias (Vigilância Sanitária);</li>
                <li>Auto de Vistoria do Corpo de Bombeiros (AVCB);</li>
                <li>Licenças ambientais;</li>
                <li>Autorizações especiais de funcionamento; e</li>
                <li>Renovações e atualizações de alvarás.</li>
              </ul>
              
              <p>
                Na Veridicus, simplificamos a obtenção e renovação de licenças por meio de uma gestão integrada e digital. 
                Monitoramos prazos, organizamos documentos e acompanhamos protocolos em tempo real, garantindo que nenhuma 
                obrigação seja esquecida. Assim, sua empresa mantém todas as autorizações em dia, evita riscos de irregularidades e 
                ganha tranquilidade para focar no crescimento.
              </p>
            </div>
            
            <div className="alvaras-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="alvaras-navigation">
          <Link to="/servicos/gestao-cadastros" className="nav-prev">
            ← GESTÃO DE CADASTROS FISCAIS E SOCIETÁRIOS
          </Link>
          <Link to="/servicos/documentos" className="nav-next">
            CRIAÇÃO E GESTÃO DE DOCUMENTOS JURÍDICOS →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default AlvarasPage;